import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

const FaqSection = ({ faqs, heading = "Frequently Asked Questions", className = "" }) => (
  <section className={`py-16 md:py-20 ${className}`} data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-5 lg:px-12">
      <div className="mb-8">
        <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Good Questions</span>
        <h2 className="text-3xl md:text-4xl font-light text-white mt-2">{heading}</h2>
      </div>
      <Accordion type="single" collapsible className="border border-zinc-800 bg-[#141414]">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-zinc-800 px-5" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-white text-lg font-semibold py-5 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FaqSection;
